import React from 'react'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA' htmlFor='input-fecha-resumen-bajas' xs={4} xl={5} alignRightAt='xs' />
      <Col md={8}>
        <Form.InputDate name='inputFecha' value={value} onChange={onChange} id='input-fecha-resumen-bajas' />
      </Col>
    </Form.Group>
  )
}

export default FechaFormGroup
